// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5314":"css/admin-app.6682","8585":"css/app.6682"}[chunkId] + ".css";
};